export const PRESET_RATIO = {
  square: 'aspect-[1/1]',
  portrait: 'aspect-[3/4]',
  landscape: 'aspect-[4/3]',
  wide: 'aspect-[16/9]',
  tall: 'aspect-[2/3]',
};
